import { linkToDashboard } from "features/dashboard/links";

import { makeLinkToStartCourseScreen } from "../courses-page/links";

export function linkToStudentClassPagePrefix() {
  return `${linkToDashboard()}/class`;
}

export function linkToStudentClassPage(classId: string = ":classId") {
  return `${linkToStudentClassPagePrefix()}/${classId}`;
}

export function linkToStudentClassAssignments(classId?: string) {
  return `${linkToStudentClassPage(classId)}/assignments`;
}

export function linkToStudentClassAssignment(
  classId?: string,
  assignmentId: string = ":assignmentId"
) {
  return `${linkToStudentClassAssignments(classId)}/assignment/${assignmentId}`;
}

export function linkToAssignmentJoinClass(
  classId?: string,
  assignmentId: string = ":assignmentId"
) {
  return `${linkToStudentClassAssignment(classId, assignmentId)}/join-class`;
}

export function linkToStudentClassLeaderboard(classId?: string) {
  return `${linkToStudentClassPage(classId)}/leaderboard`;
}

export function linkToStudentClassLeaderboardInviteLink(classId?: string) {
  return `${linkToStudentClassLeaderboard(classId)}/invite`;
}

export function linkToStudentClassSettings(classId?: string) {
  return `${linkToStudentClassPage(classId)}/settings`;
}

export function linkToStudentLeaveClass(classId?: string) {
  return `${linkToStudentClassSettings(classId)}/leave`;
}

export function linkToStudentJoinClass(classId: string) {
  return `${linkToStudentClassAssignments(classId)}/join-class`;
}

export function linkToClassAssignmentsStartCourseScreen(
  classId?: string,
  courseId?: string
) {
  return makeLinkToStartCourseScreen(
    linkToStudentClassAssignments(classId),
    courseId
  );
}
